import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'et-journal-is-final-tag',
  imports: [],
  templateUrl: './is-final-tag.component.html',
  styleUrl: './is-final-tag.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IsFinalTagComponent {
  @Input({
    required: true,
    transform: (value: boolean | null | undefined) => Boolean(value),
  })
  isFinal!: boolean;
}
